// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"95c96dba","160":"49a0e7de","208":"6d281b4c","293":"0d570eb0","516":"2ee52bd5","519":"c872732a","906":"7741ddeb","917":"bc05ec99","946":"a7c12ff3"}[chunkId] + ".chunk.js";
};